import {useFormContext} from "react-hook-form";

import {Chip} from "@/components/chip/Chip.tsx";
import {MoreList} from "@/components/moreList/MoreList.tsx";
import {AnalyzerCheckCellProps, AnalyzerCreateFormValues} from "@/pages/analyzer/Analyzer.types.ts";
import {resolveContactGroupNames} from "@/pages/analyzer/Analyzer.utils.ts";
import {useAnalyzerContext} from "@/pages/analyzer/hooks/AnalyzerContext.tsx";

export const AnalyzerCheckContactsCell = ({check}: AnalyzerCheckCellProps) => {
  const {formData} = useAnalyzerContext();
  const {watch} = useFormContext<AnalyzerCreateFormValues>();
  const contactGroups = watch("contactGroups");
  const names = check.contact_groups ?? resolveContactGroupNames(contactGroups, formData?.contactGroups.items ?? []);
  if (!names.length) {
    return null;
  }
  return (
    <MoreList
      entries={names}
      showEntries={2}
      variant="tooltip"
      renderer={(name) => (
        <Chip variant="tag" size="smallLight">
          {name}
        </Chip>
      )}
    />
  );
};
